import { useState } from "react";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import CampoNumber from "../Campo/CampoNumber";
import CampoSelect from "../Campo/CampoSelect";
import { UnidadeDeMedida } from "../../enums/UnidadeDeMedida";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { MetaFisica } from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import { MetaAplicacaoRecurso } from "../../model/PlanoDeTrabalho/PlanoAplicacao";

type Props = {
  refMeta?: MetaAplicacaoRecurso;
  closeModal: Function;
  list: MetaAplicacaoRecurso[];
  setList: Function;
  listaMetas: MetaFisica[];
  tipo: string;
  index?: number;
};

const ModalAplicacaoRecurso = ({
  refMeta,
  closeModal,
  list,
  setList,
  listaMetas,
  tipo,
  index,
}: Props) => {
  const [metaFisica, setMetaFisica] = useState(
    refMeta?.meta_execucao_fisico_id || 0
  );
  const [etapa, setEtapa] = useState(refMeta?.etapa || 1);
  const [fase, setFase] = useState(refMeta?.fase || 1);
  const [custo, setCusto] = useState(refMeta?.custo_unitario || 0);
  const [especificacao, setEspecificacao] = useState(
    refMeta?.especificacao || ""
  );
  const [unidadeMedida, setUnidadeMedida] = useState(
    refMeta?.unidade_medida || UnidadeDeMedida.mes
  );
  const [quantidade, setQuantidade] = useState(refMeta?.quantidade || 1);
  const [recursoPublico, setPublico] = useState(
    refMeta?.valor_parceiro_publico || 0
  );
  const [recursoPrivado, setPrivado] = useState(
    refMeta?.valor_parceiro_privado || 0
  );

  return (
    <form className={styles.formModal}>
      <h2>Criar Aplicação de Recurso</h2>

      <CampoSelect
        title="Meta Fisica"
        setter={setMetaFisica}
        value={metaFisica}
      >
        {listaMetas &&
          listaMetas.map((metaFisica, index) => (
            <option value={index} key={index}>
              {`${metaFisica.etapa}.${
                metaFisica.fase
              } - ${metaFisica.descricao.substring(0, 70)}${
                metaFisica.descricao.length > 70 ? "..." : ""
              }`}
            </option>
          ))}
      </CampoSelect>

      <div className={styles.gridCampos}>
        <CampoNumber title="Etapa" setter={setEtapa} value={etapa} min={1} />

        <CampoNumber title="Fase" setter={setFase} value={fase} min={1} />
      </div>
      <div className={styles.gridCampos}>
        <CampoNumber
          title="Custo Unitário"
          step={0.25}
          setter={setCusto}
          value={custo}
          min={0}
        />
        <div className={styles.gridCampos}>
          <CampoNumber
            title="Parceiro Público"
            step={0.25}
            setter={setPublico}
            value={recursoPublico}
            min={0}
          />

          <CampoNumber
            title="Parceiro Privado"
            step={0.25}
            setter={setPrivado}
            value={recursoPrivado}
            min={0}
          />
        </div>
      </div>
      <CampoTextoLongo
        title="Especificação"
        placeholder="Especifique a Aplicação desse Recurso"
        required={true}
        customValidity="Preencha com um detalhamento a respeito da Aplicação desse Recurso"
        setter={setEspecificacao}
        value={especificacao}
      />
      <div className={styles.gridCampos}>
        <CampoSelect
          title="Unidade de Medida"
          setter={setUnidadeMedida}
          value={unidadeMedida}
        >
          <option value={UnidadeDeMedida.dia}>Dias</option>
          <option value={UnidadeDeMedida.semana}>Semanas</option>
          <option value={UnidadeDeMedida.mes} defaultChecked>
            Mêses
          </option>
          <option value={UnidadeDeMedida.ano}>Anos</option>
        </CampoSelect>
        <CampoNumber
          title="Quantidade"
          setter={setQuantidade}
          value={quantidade}
          customValidity="A quantidade não pode ser 0"
          min={1}
        />
      </div>
      <hr className={styles.separador} />
      {!refMeta && (
        <input
          type="submit"
          value="+ Adicionar Aplicação"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            if (VerificaForm(e.currentTarget.form)) {
              const item: MetaAplicacaoRecurso = {
                meta_execucao_fisico_id: metaFisica,
                etapa: etapa,
                fase: fase,
                especificacao: especificacao,
                quantidade: quantidade,
                unidade_medida: unidadeMedida,
                custo_unitario: custo,
                valor_parceiro_publico: recursoPublico,
                valor_parceiro_privado: recursoPrivado,
                tipo: tipo,
              };
              addList({ item, list, setList });
              closeModal();
            }
          }}
        />
      )}

      {refMeta !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Meta"
            className={styles.editBtn}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              if (VerificaForm(e.currentTarget.form)) {
                const item: MetaAplicacaoRecurso = {
                  meta_execucao_fisico_id: metaFisica,
                  etapa: etapa,
                  fase: fase,
                  especificacao: especificacao,
                  quantidade: quantidade,
                  unidade_medida: unidadeMedida,
                  custo_unitario: custo,
                  valor_parceiro_publico: recursoPublico,
                  valor_parceiro_privado: recursoPrivado,
                  tipo: tipo,
                };
                editList({
                  item,
                  setList,
                  list,
                  index,
                });

                closeModal();
              }
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalAplicacaoRecurso;
